import { useTheme } from "@/context/ThemeContext";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Contrast } from "lucide-react";

const MODES = [
  { id: "light", label: "Claro (sanitario)" },
  { id: "dark", label: "Oscuro" },
  { id: "high-contrast", label: "Alto contraste" },
];

export default function Settings() {
  const { mode, setMode, voiceAssist, setVoiceAssist, largeText, setLargeText } = useTheme();
  const { user } = useAuth();

  return (
    <div className="space-y-8 max-w-2xl" data-testid="settings-page">
      <div>
        <p className="text-sm uppercase tracking-widest text-primary font-semibold">Ajustes</p>
        <h1 className="heading text-3xl font-extrabold mt-1">Accesibilidad y cuenta</h1>
      </div>

      <Card className="rounded-2xl border-border">
        <CardHeader>
          <CardTitle className="heading flex items-center gap-2"><Contrast size={18} /> Modo visual</CardTitle>
          <CardDescription>Elige la apariencia que mejor te funcione.</CardDescription>
        </CardHeader>
        <CardContent className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {MODES.map((m) => (
            <Button key={m.id} onClick={() => setMode(m.id)} data-testid={`mode-${m.id}`}
              variant={mode === m.id ? "default" : "outline"} className="rounded-full h-11">
              {m.label}
            </Button>
          ))}
        </CardContent>
      </Card>

      <Card className="rounded-2xl border-border">
        <CardHeader><CardTitle className="heading">Accesibilidad</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between">
            <Label htmlFor="voice" className="text-base">Narración por voz (dispositivo)</Label>
            <Switch id="voice" checked={voiceAssist} onCheckedChange={setVoiceAssist} data-testid="switch-voice" />
          </div>
          <div className="flex items-center justify-between">
            <Label htmlFor="large" className="text-base">Texto grande</Label>
            <Switch id="large" checked={largeText} onCheckedChange={setLargeText} data-testid="switch-large" />
          </div>
        </CardContent>
      </Card>

      <Card className="rounded-2xl border-border">
        <CardHeader><CardTitle className="heading">Cuenta</CardTitle></CardHeader>
        <CardContent className="space-y-1">
          <p><span className="text-muted-foreground">Nombre:</span> {user?.name}</p>
          <p><span className="text-muted-foreground">Correo:</span> {user?.email}</p>
          <p><span className="text-muted-foreground">Rol:</span> {user?.role}</p>
        </CardContent>
      </Card>
    </div>
  );
}
